import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LoginStyles from "../../styles/loginPageStyles.module.css";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import {
  resetPassword,
  verifyExpirationToken,
} from "../../network/apis/auth.api";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";

const UpdatePassword = () => {
  const { loginWithRedirect } = useAuth0();
  const token = new URLSearchParams(useLocation().search).get("token");
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isTokenValid, setIsTokenValid] = useState(true);

  useEffect(() => {
    const checkTokenValidity = async () => {
      try {
        const response = await verifyExpirationToken(token);
        if (response.isValidToken) {
          setIsTokenValid(true);
        } else {
          setIsTokenValid(false);
        }
      } catch (error) {
        setIsTokenValid(false);
      }
    };

    if (token) {
      checkTokenValidity();
    } else {
      setIsTokenValid(false);
    }
  }, [token]);

  const validateForm = () => {
    const {  newPassword, confirmNewPassword } = formData;
    return newPassword && newPassword === confirmNewPassword;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrorMessage("");
    setSuccessMessage("");
  };

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const {  newPassword } = formData;

      const passwordDetails = {
        token,
        newPassword,
      };
      try {
        const response = await resetPassword(passwordDetails);
        setSuccessMessage("Your password has been successfully updated.");
        setFormData({
          newPassword: "",
          confirmNewPassword: "",
        });

        setTimeout(() => {
          loginWithRedirect()
        }, 3000);
      } catch (error) {
        if (error.response) {
          setErrorMessage(
            `Error: ${
              error.response.data.error ||
              "An error occurred. Please try again."
            }`
          );
        } else if (error.request) {
          setErrorMessage(
            "Error: No response from the server. Please check your internet connection."
          );
        } else {
          setErrorMessage(`Error: ${error.message}`);
        }
      }
    } else {
      setErrorMessage(
        "Please ensure all fields are filled out correctly and the new passwords match."
      );
    }
  };

  if (!isTokenValid) {
    return (
      <Container
        component="main"
        maxWidth="xs"
        className={LoginStyles.login_form_container}
      >
        <Box
          sx={{
            marginTop: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography mb={0.5} component="h1" variant="h5">
            Link Expired
          </Typography>

          <Alert severity="error" fullWidth>
            The password reset link has expired. Please{" "}
            <Link href="/forgot-password" underline="always">
              request a new link
            </Link>
            .
          </Alert>
        </Box>
      </Container>
    );
  }

  return (
    <>
      <Container
        component="main"
        maxWidth="xs"
        className={LoginStyles.login_form_container}
      >
        <Box
          sx={{
            marginTop: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h1" variant="h5">
            Update Password
          </Typography>

          <Box
            component="form"
            noValidate
            onSubmit={handlePasswordUpdate}
            sx={{ mt: 0.5 }}
          >
            {errorMessage && (
              <Alert severity="error" fullWidth>
                {errorMessage}
              </Alert>
            )}
            {successMessage && (
              <Alert severity="success" fullWidth>
                {successMessage}
              </Alert>
            )}

            <Grid container spacing={2} mt={0.5}>
             
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  size="small"
                  name="newPassword"
                  label="New Password"
                  type="password"
                  value={formData.newPassword}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  size="small"
                  name="confirmNewPassword"
                  label="Confirm New Password"
                  type="password"
                  value={formData.confirmNewPassword}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                px: 10,
                backgroundColor: "#0c0092",
                fontWeight: "bold",
              }}
            >
              Update Password
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default UpdatePassword;
